import { ElementType, ReactNode } from "react";
import { Form, InputGroup } from "react-bootstrap";

export const ReadonlyGroup = ({
    label,
    value,
    as,
    append,
    inlineLabel,
    isCurrency,
}: {
    label: ReactNode;
    value?: string | number;
    as?: ElementType;
    append?: string;
    inlineLabel?: boolean;
    isCurrency?: boolean;
}) => {
    return (
        <Form.Group className="mb-2">
            <div className={inlineLabel ? "d-flex align-items-center" : ""}>
                <Form.Label style={{ whiteSpace: "nowrap" }} className={inlineLabel ? "me-2" : ""}>
                    {label}
                </Form.Label>
                <InputGroup>
                    {isCurrency && <InputGroup.Text>$</InputGroup.Text>}
                    <Form.Control as={as} disabled value={value} />
                    {!!append && <InputGroup.Text>{append}</InputGroup.Text>}
                </InputGroup>
            </div>
        </Form.Group>
    );
};
